/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_TreeInputs */

const cs_documents_tree = /** @type {(inputs: Documents_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Složky`)
};

const en_documents_tree = /** @type {(inputs: Documents_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders`)
};

/**
* | output |
* | --- |
* | "Folders" |
*
* @param {Documents_TreeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_tree = /** @type {((inputs?: Documents_TreeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_TreeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_tree(inputs)
	return cs_documents_tree(inputs)
});